import config from "@/config";
import {Conversation, Message} from "@/models";

export default (app) => {
    return {
        namespaced: true,

        actions: {
            async getOperatorUsers({rootState}) {
                const r = await window.http.get(`${config.API_URL}/operator/users`);
                return r.data || [];
            },

            async getInternalUserConversations({rootState}, userId) {
                const r = await window.http.get(`${config.API_URL}/operator/users/${userId}/conversations`);
                if (r.success) {
                    return r.data.map(e => Conversation(e, rootState));
                }

                return [];
            },
        },
    };
};
